import { Row } from '@shipt/design-system-layouts'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import { useUtmUrl } from '@/features/shared/hooks/useUtmUrl'
import { routes } from '@shared/constants/routes'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { type ComponentProps } from 'react'

type Props = { linkSize?: ComponentProps<typeof ButtonLink>['size'] }

export const HeaderUserLinks = ({ linkSize = 'md' }: Props) => {
  const loginUrl = useUtmUrl(routes.LOGIN.url)
  const signupUrl = useUtmUrl(routes.SIGN_UP.url)
  const { isSessionLoading, isSessionValid } = useSession()

  const handleOnClickLink = (content: 'sign_in' | 'sign_up' | 'continue with account') =>
    trackElementClicked({
      type: 'link',
      content,
      display_sublocation: 'header',
    })

  if (isSessionLoading) return null

  return (
    <Row spacing="lg" align="center">
      {isSessionValid ? (
        <ButtonLink
          href={routes.GLOBAL_HOMEPAGE.url}
          onClick={() => handleOnClickLink('continue with account')}
          variant="secondary"
          size={linkSize}
        >
          Continue with account
        </ButtonLink>
      ) : (
        <>
          <ButtonLink
            href={loginUrl}
            onClick={() => handleOnClickLink('sign_in')}
            variant="secondary"
            size={linkSize}
            nativeLink
          >
            Sign in
          </ButtonLink>
          <ButtonLink
            href={signupUrl}
            onClick={() => handleOnClickLink('sign_up')}
            size={linkSize}
            nativeLink
          >
            Sign up
          </ButtonLink>
        </>
      )}
    </Row>
  )
}
